import request from '@/utils/request';

// 获取图片验证码
export function getCaptchaImage() {
  return request({
    url: '/lock/gmwebapi/getKaptchaImage',
    method: 'get',
    params: {
      t: new Date().getTime(),
    },
    responseType: 'arraybuffer',
  });
}

// 获取短信验证码
export function getMsg(query) {
  return request({
    url: '/lock/gmwebapi/verifyCode',
    method: 'post',
    data: query,
  });
}

// 获取首页数据
export function getLowPowerOfflineCount() {
  return request({
    url: '/lock/apartwebapi/apartment/getLowPowerOfflineCount',
    method: 'get',
  });
}
